import { render, staticRenderFns } from "./product.vue?vue&type=template&id=20cf34a2&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=20cf34a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf34a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20cf34a2')) {
      api.createRecord('20cf34a2', component.options)
    } else {
      api.reload('20cf34a2', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=20cf34a2&scoped=true", function () {
      api.rerender('20cf34a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/index/product.vue"
export default component.exports